function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var patterns_exports = {};
__export(patterns_exports, {
  AUDIO_EXTENSIONS: function AUDIO_EXTENSIONS() {
    return _AUDIO_EXTENSIONS;
  },
  DASH_EXTENSIONS: function DASH_EXTENSIONS() {
    return _DASH_EXTENSIONS;
  },
  FLV_EXTENSIONS: function FLV_EXTENSIONS() {
    return _FLV_EXTENSIONS;
  },
  HLS_EXTENSIONS: function HLS_EXTENSIONS() {
    return _HLS_EXTENSIONS;
  },
  MATCH_URL_DAILYMOTION: function MATCH_URL_DAILYMOTION() {
    return _MATCH_URL_DAILYMOTION;
  },
  MATCH_URL_FACEBOOK: function MATCH_URL_FACEBOOK() {
    return _MATCH_URL_FACEBOOK;
  },
  MATCH_URL_FACEBOOK_WATCH: function MATCH_URL_FACEBOOK_WATCH() {
    return _MATCH_URL_FACEBOOK_WATCH;
  },
  MATCH_URL_KALTURA: function MATCH_URL_KALTURA() {
    return _MATCH_URL_KALTURA;
  },
  MATCH_URL_MIXCLOUD: function MATCH_URL_MIXCLOUD() {
    return _MATCH_URL_MIXCLOUD;
  },
  MATCH_URL_MUX: function MATCH_URL_MUX() {
    return _MATCH_URL_MUX;
  },
  MATCH_URL_SOUNDCLOUD: function MATCH_URL_SOUNDCLOUD() {
    return _MATCH_URL_SOUNDCLOUD;
  },
  MATCH_URL_STREAMABLE: function MATCH_URL_STREAMABLE() {
    return _MATCH_URL_STREAMABLE;
  },
  MATCH_URL_TWITCH_CHANNEL: function MATCH_URL_TWITCH_CHANNEL() {
    return _MATCH_URL_TWITCH_CHANNEL;
  },
  MATCH_URL_TWITCH_VIDEO: function MATCH_URL_TWITCH_VIDEO() {
    return _MATCH_URL_TWITCH_VIDEO;
  },
  MATCH_URL_VIDYARD: function MATCH_URL_VIDYARD() {
    return _MATCH_URL_VIDYARD;
  },
  MATCH_URL_VIMEO: function MATCH_URL_VIMEO() {
    return _MATCH_URL_VIMEO;
  },
  MATCH_URL_WISTIA: function MATCH_URL_WISTIA() {
    return _MATCH_URL_WISTIA;
  },
  MATCH_URL_YOUTUBE: function MATCH_URL_YOUTUBE() {
    return _MATCH_URL_YOUTUBE;
  },
  VIDEO_EXTENSIONS: function VIDEO_EXTENSIONS() {
    return _VIDEO_EXTENSIONS;
  },
  canPlay: function canPlay() {
    return _canPlay;
  }
});
module.exports = __toCommonJS(patterns_exports);
var import_utils = require("./utils");
var _MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
var _MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
var _MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
var _MATCH_URL_MUX = /stream\.mux\.com\/(\w+)/;
var _MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
var _MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
var _MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
var _MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
var _MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var _MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
var _MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/;
var _MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
var _MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
var _MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
var _AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var _VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
var _HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var _DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var _FLV_EXTENSIONS = /\.(flv)($|\?)/i;
var canPlayFile = function canPlayFile(url) {
  if (url instanceof Array) {
    var _iterator2 = _createForOfIteratorHelper(url),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        if (typeof item === "string" && canPlayFile(item)) {
          return true;
        }
        if (canPlayFile(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return false;
  }
  if ((0, import_utils.isMediaStream)(url) || (0, import_utils.isBlobUrl)(url)) {
    return true;
  }
  return _AUDIO_EXTENSIONS.test(url) || _VIDEO_EXTENSIONS.test(url) || _HLS_EXTENSIONS.test(url) || _DASH_EXTENSIONS.test(url) || _FLV_EXTENSIONS.test(url);
};
var _canPlay = {
  youtube: function youtube(url) {
    if (url instanceof Array) {
      return url.every(function (item) {
        return _MATCH_URL_YOUTUBE.test(item);
      });
    }
    return _MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: function soundcloud(url) {
    return _MATCH_URL_SOUNDCLOUD.test(url) && !_AUDIO_EXTENSIONS.test(url);
  },
  vimeo: function vimeo(url) {
    return _MATCH_URL_VIMEO.test(url) && !_VIDEO_EXTENSIONS.test(url) && !_HLS_EXTENSIONS.test(url);
  },
  mux: function mux(url) {
    return _MATCH_URL_MUX.test(url);
  },
  facebook: function facebook(url) {
    return _MATCH_URL_FACEBOOK.test(url) || _MATCH_URL_FACEBOOK_WATCH.test(url);
  },
  streamable: function streamable(url) {
    return _MATCH_URL_STREAMABLE.test(url);
  },
  wistia: function wistia(url) {
    return _MATCH_URL_WISTIA.test(url);
  },
  twitch: function twitch(url) {
    return _MATCH_URL_TWITCH_VIDEO.test(url) || _MATCH_URL_TWITCH_CHANNEL.test(url);
  },
  dailymotion: function dailymotion(url) {
    return _MATCH_URL_DAILYMOTION.test(url);
  },
  mixcloud: function mixcloud(url) {
    return _MATCH_URL_MIXCLOUD.test(url);
  },
  vidyard: function vidyard(url) {
    return _MATCH_URL_VIDYARD.test(url);
  },
  kaltura: function kaltura(url) {
    return _MATCH_URL_KALTURA.test(url);
  },
  file: canPlayFile
};